import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import MarketingPublicNav from '../components/MarketingPublicNav';
import { PublicBandSection, PublicMarketingLayout } from '../components/PublicMarketingLayout';

const NotFound: React.FC = () => {
  return (
    <PublicMarketingLayout>
      <MarketingPublicNav />

      <PublicBandSection band={1} className="px-6 pb-8 pt-24 text-center font-sans">
        <div className="mx-auto max-w-2xl">
          <div className="relative mb-8">
            <div className="bg-gradient-to-r from-violet-500 to-blue-500 bg-clip-text text-[8rem] font-bold leading-none text-transparent sm:text-[12rem]">
              404
            </div>
          </div>

          <h1 className="mb-4 bg-gradient-to-r from-violet-500 to-blue-500 bg-clip-text text-4xl font-bold text-transparent md:text-5xl">
            Page Not Found
          </h1>
          <p className="mb-8 text-xl text-gray-400">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="mb-12 flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-violet-600 to-blue-500 px-8 py-4 text-lg font-semibold text-white transition-all hover:shadow-xl hover:shadow-violet-500/30"
            >
              Go Home
            </Link>
            <Link
              to="/help"
              className="rounded-lg border border-white/10 bg-white/5 px-8 py-4 text-lg font-semibold text-white transition-all hover:bg-white/10"
            >
              Get Help
            </Link>
            <Link
              to="/contact"
              className="rounded-lg border border-white/10 bg-white/5 px-8 py-4 text-lg font-semibold text-white transition-all hover:bg-white/10"
            >
              Contact Us
            </Link>
          </div>

          <div className="text-sm text-gray-500">
            <p>Error Code: PAGE_NOT_FOUND</p>
            <p>Timestamp: {new Date().toISOString()}</p>
          </div>
        </div>
      </PublicBandSection>

      <PublicBandSection band={2} className="px-6 pb-20">
        <div className="mx-auto max-w-4xl">
          <h2 className="mb-6 bg-gradient-to-r from-violet-500 to-blue-500 bg-clip-text text-2xl font-bold text-transparent">
            You might be looking for:
          </h2>
          <div className="grid gap-4 md:grid-cols-3">
            <Link
              to="/features"
              className="rounded-lg border border-white/10 bg-white/5 p-4 text-left transition-colors hover:bg-white/10"
            >
              <div className="mb-2 text-3xl">Features</div>
              <h3 className="mb-1 font-bold text-white">Features</h3>
              <p className="text-sm text-gray-400">Explore our platform capabilities</p>
            </Link>
            <Link
              to="/pricing"
              className="rounded-lg border border-white/10 bg-white/5 p-4 text-left transition-colors hover:bg-white/10"
            >
              <div className="mb-2 text-3xl">Pricing</div>
              <h3 className="mb-1 font-bold text-white">Pricing</h3>
              <p className="text-sm text-gray-400">View our plans and pricing</p>
            </Link>
            <Link
              to="/faq"
              className="rounded-lg border border-white/10 bg-white/5 p-4 text-left transition-colors hover:bg-white/10"
            >
              <div className="mb-2 text-3xl">FAQ</div>
              <h3 className="mb-1 font-bold text-white">FAQ</h3>
              <p className="text-sm text-gray-400">Find answers to common questions</p>
            </Link>
          </div>
        </div>
      </PublicBandSection>

      <Footer />
    </PublicMarketingLayout>
  );
};

export default NotFound;
